import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";

if (import.meta.env.PROD) {
  const reportError = (message: string, source: string, stack?: string) => {
    try {
      fetch("/api/client-error", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message,
          stack: stack || source,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        }),
      }).catch(() => {});
    } catch {}
  };

  window.addEventListener("error", (event) => {
    reportError(
      event.message || "Unknown error",
      event.filename || "unknown",
      event.error?.stack
    );
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    reportError(
      reason?.message || String(reason) || "Unhandled promise rejection",
      "unhandledrejection",
      reason?.stack
    );
  });
}

createRoot(document.getElementById("root")!).render(<App />);
